import React from 'react';

export const AuctionName = (props) => {
    return(
        <div className='text-center'>
          <h1>{props.data.name}</h1>
        </div>
    );
}
